export default {
  historicalData: {
    small: 'Select to include older versions of records, where available, from a time period you specify.',
    full: '',
  },
  meetAny: {
    small: '',
    full: '',
  },
  saveSearch: {
    small: '',
    full: '',
  },
  resetSearch: {
    small: 'Click to clear all search options. Your current search will not be saved.',
    full: '',
  },
  relationship: {
    small: 'Choose whether to look for search criteria in the record of the entity itself or in related entity records.',
    full: '',
  },
  leiData: {
    small: 'Select which data fields to search, including relationship network features. ',
    full: 'Options include specific data fields; all data fields; free-text fields only (as in the simple search); network features such as the absolute count of related entities  to records (e.g., parent, child, sub-funds, branches) you are searching for.',
  },
  operator: {
    small: 'Select an operator to specify how a search criterion is matched in LEI data fields.',
    full: 'Operators include partial, full, or negative matching for text; equal, not equal, greater, less than, etc. for numbers and dates. Available operators depend on the type of data allowed for each LEI data field.',
  },
  searchValue: {
    small: 'Enter the data value you are looking for.',
    full: 'The type of data you can enter for search depends on the LEI data field selected.',
  },
  searchCriteria: {
    small: 'Search on full data records, or calculated characteristics of the relationship network.',
    full: '',
  },
  addSearchCriteria: {
    small: 'Click to add another search critierion. Criteria are combined with logical "AND"',
    full: '',
  },
  serchNow: {
    small: 'Click to apply the current search query and see the results.',
    full: '',
  },
}



// WEBPACK FOOTER //
// ./src/constants/tooltips/expert.js